module.exports = __webpack_public_path__ + "static/media/Manaphy_gaussian2.c1826802.png";